import ImageLazyLoader from 'components/common/ImageLazyLoader';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
/**
* Render images with different src files depending on what SiteMerch populates in Symphony
*/
export const LandingPageImage = ({
  src = null,
  mobilesrc = null,
  tabletsrc = null,
  retina = null,
  mobileretina = null,
  tabletretina = null,
  alt = null,
  title = null,
  width = null,
  height = null,
  role = null,
  itemProp = null,
  shouldLazyLoad = false,
  className = null,
  imgTestId = null
}) => {

  const altString = !alt || alt === '""' ? '' : alt;

  const makeSrcSet = (bp, reg, ret) => {
    if (!reg) {
      return;
    } else {
      let srcset = reg;
      if (ret) {
        srcset += `, ${ret} 2x`;
      }
      return (<source key={bp + reg} media={`(max-width: ${bp})`} srcSet={srcset} />);
    }
  };
  const mblSrc = makeSrcSet('650px', mobilesrc, mobileretina);
  const tblSrc = makeSrcSet('1024px', tabletsrc, tabletretina);
  const pictureProps = [
    ...(mblSrc ? [ mblSrc ] : []),
    ...(tblSrc ? [ tblSrc ] : []),
    ...((!mblSrc && !tblSrc) ? [ makeSrcSet('0px', src) ] : [])// force pictureProps to have content for lazyLoad
  ];
  const srcSet = retina && `${retina} 2x, ${src} 1x`;
  const imgProps = { src, title, width, height, srcSet, role, itemProp, 'alt': altString, 'data-test-id': imgTestId };
  if (src) {
    if (shouldLazyLoad) {
      return <ImageLazyLoader
        className={className}
        imgProps={imgProps}
        pictureProps={pictureProps}/>;
    } else {
      return (
        <picture>
          {pictureProps}
          <img
            src={src}
            alt={altString}
            title={title}
            width={width}
            height={height}
            srcSet={retina ? `${retina} 2x, ${src} 1x` : null}
            role={role}
            itemProp={itemProp}
            data-test-id={imgTestId}
          />
        </picture>
      );
    }
  }
  return null;
};

export default withErrorBoundary('LandingPageImage', LandingPageImage);
